import { useEffect } from 'react';

import { useParams } from 'react-router-dom';

import pageComponents from '#client/constants/pageComponents';
import useFlowState from '#client/hooks/flow/useFlowState';
import useFlowPageConfig from '#client/hooks/useFlowPageConfig';
import useFlowPageExperiment from '#client/hooks/useFlowPageExperiment';

function FlowPage() {
  const { flowPage } = useParams();
  const { set } = useFlowState();

  const { pageComponent, pageComponentProps } = useFlowPageConfig(flowPage);
  const Component = pageComponents[pageComponent];

  if (!Component) {
    throw new Error(`No page component found for: ${flowPage}`);
  }

  const { props } = useFlowPageExperiment(pageComponent, pageComponentProps);

  // Keep track of the last page visited.
  // The FlowPageGate will ensure we don't save incorrectly.
  useEffect(() => {
    set('lastPage', flowPage);
  }, [flowPage, set]);

  return <Component {...props} />;
}

export default FlowPage;
